import { request } from './utils';

export default class AffiliateService {
    static async getAll() {
        const response = await request('/api/affiliates');
        return response.data;
    }

    static async setNachaProvider(affiliateId, nachaProvider) {
        const response = await request(`/api/affiliates/${affiliateId}`, {
            method: 'PATCH',
            data: JSON.stringify({ nachaProvider })
        });
        return response.data;
    }
}
